const CompanyInputHook = {
  mounted() {
    const autocompleteByDomainInput = document.getElementById(
      this.el.dataset.autocompleteByDomainInputId,
    )
    const autocompleteByNameInput = document.getElementById(
      this.el.dataset.autocompleteByNameInputId,
    )
    const companyInput = document.getElementById(this.el.dataset.companyInputId)

    this.el.addEventListener("autocomplete:item-select", (e) => {
      if (e.detail.data == "enaia:skip_options") {
        console.log(`${e.detail}`)
      } else {
        autocompleteByDomainInput.value = JSON.stringify(e.detail.data)
        autocompleteByDomainInput.dispatchEvent(
          new Event("input", { bubbles: true }),
        )
        autocompleteByDomainInput.value = null
      }
    })

    this.el.addEventListener("autocomplete:leaving", (e) => {
      autocompleteByNameInput.value = e.target.value
      autocompleteByNameInput.dispatchEvent(
        new Event("input", { bubbles: true }),
      )
      autocompleteByNameInput.value = null
    })

    const displayInput = this.el.querySelector('input[type="text"]')
    displayInput.addEventListener("input", (e) => {
      companyInput.value = e.target.value
      companyInput.dispatchEvent(new Event("input", { bubbles: true }))
    })
  },
}

export { CompanyInputHook }
